import { UserSettingsModal } from "@desktop/components/Profile/Settings";
import { showBonusModal } from "@shared/actions/bonuses";
import { getLobbyParams } from "@shared/actions/lobby";
import { BonusButton, Sweepstakes } from "@shared/components";
import { useBonuses } from "@shared/hooks/bonuses";
import { useLobbyParams } from "@shared/hooks/lobby";
import { $f } from "@shared/hooks/shared";
import { useUser } from "@shared/hooks/user";
import { root } from "@shared/utils";
import { get } from "lodash-es";
import React, { useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import InnerModal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const customStyles = {
  overlay: {
    zIndex: 99999,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
};

const Modal = ({ defaultTab, close, showModal }) => {
  const [overlayShow, setOverlayShow] = React.useState(true);
  const [currentTab, setCurrentTab] = React.useState(0);
  const [defaultTabLocal, setDefaultTabLocal] = React.useState(0);
  const refModalContent = React.useRef(null);
  const params = useSelector((state) => state.lobby.params);
  const user = useUser();
  const { bonus } = useBonuses();
  const dispatch = useDispatch();
  const { sweepstakes: isSweepstakesEnabled } = useLobbyParams() ?? {};

  useEffect(() => {
    dispatch(getLobbyParams());
  }, [dispatch]);

  useEffect(() => {
    if (!overlayShow) {
      setOverlayShow(true);
    }

    if (defaultTabLocal !== defaultTab) {
      setDefaultTabLocal(defaultTab);
      setCurrentTab(defaultTabLocal);
    }
  }, [defaultTabLocal, defaultTab, overlayShow]);

  const handleOverlay = useCallback(
    (event) => {
      if (overlayShow && !refModalContent?.current?.contains(event.target)) {
        setOverlayShow(false);
        close();
      }
    },
    [overlayShow, close]
  );

  const changeTab = (index) => {
    setCurrentTab(index);
  };

  const nickname = user?.name || user?.displayable_name;
  const realBalance = $f.formatMoney($f.toMoney(user.balance));
  const realCurrency = user?.currency;

  const hasDeposit = get(params, "lobbyButtons.deposit.enabled", false);
  const hasWithdraw = get(params, "lobbyButtons.withdraw.enabled", false);

  return (
    <InnerModal
      isOpen={showModal && overlayShow}
      contentLabel="User Modal"
      style={customStyles}
      parentSelector={() => document.getElementById("mainSection")}
      className="overlay overlay-wrap"
      appElement={root}
    >
      <div className="overlay" onClick={handleOverlay}>
        <div className="scrollarea">
          <div className="scrollarea__inner">
            <div className="scrollarea__content">
              <div className="modal modal_profile">
                <div className="modal__close ico ico-close" onClick={close} />
                <div className="profile" ref={refModalContent}>
                  <div className="modal__head">
                    <div className="profile__info">
                      <div className="profile__name">
                        <b>{nickname}</b>
                      </div>

                      <div className="profile__data">
                        {user.email && <span>{user.email}</span>}
                        {user.id && <span>id: {user.id}</span>}
                      </div>

                      <div className="profile__balance">
                        <div className="balance-item">
                          {isSweepstakesEnabled ? (
                            <Sweepstakes user={user} />
                          ) : (
                            <>
                              <b className="balance-item__title">
                                <FormattedMessage id="boilerplate.components.ModalRoom.Balance" />
                              </b>
                              <b>
                                {realCurrency} {realBalance}
                              </b>
                            </>
                          )}
                        </div>
                      </div>

                      {bonus && bonus.available && (
                        <div className="profile__balance">
                          <div className="balance-item">
                            <BonusButton
                              bonus={bonus}
                              onClick={() => dispatch(showBonusModal())}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="profile__content">
                    <div className="profile__sticky">
                      <div className="profile__sticky-holder">
                        <Tabs
                          selectedIndex={currentTab}
                          onSelect={(tabIndex) => changeTab(tabIndex, 0)}
                          selectedTabClassName="tabset__item--selected"
                          className="profile__panel profile__panel_main"
                        >
                          <TabList className="tabset tabset_light">
                            {(hasDeposit || hasWithdraw) && (
                              <Tab className="tabset__item">
                                <div className="ico ico-cash" />
                                <FormattedMessage id="boilerplate.components.Popup.Score" />
                              </Tab>
                            )}

                            <Tab className="tabset__item">
                              <div className="ico ico-gear" />
                              <FormattedMessage id="boilerplate.components.Popup.Settings" />
                            </Tab>
                          </TabList>
                          <TabPanel>
                            <UserSettingsModal />
                          </TabPanel>
                        </Tabs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </InnerModal>
  );
};

export default Modal;
